module.exports = {
      id: "logo-usage",
      viewBox: "0 0 119 39",
      url: __webpack_public_path__ + "svg-sprite.svg#logo",
      toString: function () {
        return this.url;
      }
    }